var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',_vm._b({staticClass:"o-sheet",class:_vm.classes,style:(_vm.sheetStyle)},'v-sheet',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }